
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M277.3 33.5c-8.1 2.2-13.2 5.2-19.3 11.4-16.4 16.4-16.8 41.8-.9 58.6 9.5 10 19.6 14.1 33.3 13.3 11.4-.7 18.2-3.6 26.2-11 17.7-16.6 18.7-42.3 2.4-60.1-10.4-11.4-26.8-16.2-41.7-12.2m-33.5 96.4c-7.8 2.5-7.9 2.6-46.3 30.5-18.7 13.6-34.5 25.1-35.1 25.4-.5.4-11.8 15.5-24.9 33.7-13.1 18.1-24.2 33.5-24.6 34.1-.9 1.1 30.4 24.6 33 24.8.8.1 11.2-13.4 23.2-29.9 19.3-26.6 22.6-30.6 29.1-35.6 4-3.1 7.4-5.5 7.6-5.4.2.2-2.2 14.6-5.3 32.1-6.8 38.2-6.9 43.1-1.1 54.8 1.9 3.9 5.4 9 7.8 11.2 2.4 2.3 20.3 17.5 39.8 33.9 19.5 16.3 35.8 30.2 36.1 30.9.4.6 10.2 27.4 21.9 59.6s21.4 58.6 21.5 58.8c.3.4 38.6-13.5 39.3-14.3.3-.3-10-29.6-23-65.3l-23.5-64.7-19.9-16.8c-10.9-9.3-20.9-17.7-22.1-18.6l-2.1-1.7 6.9-39c3.7-21.4 7.1-40.3 7.3-41.9l.6-3 11.3 11c6.2 6 15.2 13.7 20 16.9 22.2 14.8 47.9 23.7 73 25.3l10.7.6v-42.2l-5.7-.6c-30.9-3.3-54.2-14.4-72.6-34.6-7.8-8.6-10.6-13.5-15.8-28.1-2.2-6.2-5.4-13.7-7-16.5-11.6-20.3-39.4-32-60.1-25.4"}}),_c('path',{attrs:{"d":"M194.7 354.1l-7.9 23.2-31.5 37.4C138 435.3 124 452.5 124.2 453c.4 1.1 31.8 27.4 32.2 26.9.2-.2 15.6-18.6 34.3-40.9l33.9-40.5 8.2-17.9c4.5-9.9 7.9-18.3 7.5-18.6-8.3-7.2-37.1-31-37.4-31-.2 0-3.9 10.4-8.2 23.1"}})])
          )
        }
      }
    